export const copyToClipboard = async (text: string): Promise<void> => {
  await navigator.clipboard.writeText(text);
};

export const copyJsonToClipboard = async (data: unknown, indent: number = 2): Promise<void> => {
  const jsonString = JSON.stringify(data, null, indent);
  await navigator.clipboard.writeText(jsonString);
};
